import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { TrendingUp, Server, ShieldCheck, Handshake, BadgeCheck } from 'lucide-react';
const visions = [{
  icon: TrendingUp,
  title: 'Nachhaltige Digitalisierung',
  desc: 'Lösungen, die langfristig Wert schaffen — nicht nur kurzfristig funktionieren.'
}, {
  icon: Server,
  title: 'Skalierbare Systeme',
  desc: 'Software, die mit Ihrem Unternehmen mitwächst.'
}, {
  icon: ShieldCheck,
  title: 'Zukunftsfähige Architektur',
  desc: 'Moderne Technologien, die auch morgen noch relevant sind.'
}, {
  icon: Handshake,
  title: 'Starke Kundenbeziehungen',
  desc: 'Partnerschaftlich, ehrlich und auf Augenhöhe — über das Projekt hinaus.'
}, {
  icon: BadgeCheck,
  title: 'Zuverlässigkeit',
  desc: 'Verbindliche Zusagen, termingerechte Umsetzung und stabile Ergebnisse.'
}];
export function VisionSlide() {
  return <SlideWrapper className="bg-bg-alt" data-id="element-228">
      <div className="h-full flex flex-col justify-center" data-id="element-229">
        <motion.div className="mb-10" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-230">
          <h2 className="text-5xl font-bold text-primary mb-4" data-id="element-231">
            Unsere Vision
          </h2>
          <div className="h-1 w-24 bg-accent rounded-full" data-id="element-232" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-233">
          {visions.slice(0, 3).map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + index * 0.12
        }} className="bg-white p-7 rounded-xl shadow-sm border border-gray-100 flex items-start gap-5" data-id="element-234">
              <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center shrink-0" data-id="element-235">
                <item.icon className="w-6 h-6 text-accent" data-id="element-236" />
              </div>
              <div data-id="element-237">
                <h3 className="text-lg font-bold text-primary mb-1" data-id="element-238">
                  {item.title}
                </h3>
                <p className="text-text-secondary text-sm leading-relaxed" data-id="element-239">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5 max-w-[calc(66.666%+0.625rem)] mx-auto w-full" data-id="element-240">
          {visions.slice(3).map((item, index) => <motion.div key={index + 3} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55 + index * 0.12
        }} className="bg-white p-7 rounded-xl shadow-sm border border-gray-100 flex items-start gap-5" data-id="element-241">
              <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center shrink-0" data-id="element-242">
                <item.icon className="w-6 h-6 text-accent" data-id="element-243" />
              </div>
              <div data-id="element-244">
                <h3 className="text-lg font-bold text-primary mb-1" data-id="element-245">
                  {item.title}
                </h3>
                <p className="text-text-secondary text-sm leading-relaxed" data-id="element-246">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </SlideWrapper>;
}